import { axiosInstanceMain } from './../../../utils/axiosGlobalUtils';

export const LoginService = async (user: {user: string, pwd: string, captcha: string}) => await axiosInstanceMain.post(`/auth/login`, user)